import _ from 'lodash'
import axios from 'axios'
import { CONFIG } from '../config'

/** Legacy Sensia uses snake_case; sidebar labels often use kebab-case. */
export function menuKeyVariants(menuID) {
  if (menuID == null || menuID === '') {
    return [menuID]
  }
  const s = String(menuID)
  const variants = new Set([s, s.replace(/-/g, '_'), s.replace(/_/g, '-')])
  return [...variants]
}

const getMenuByKeyExact = (menus, menuID) => {
  let selectedMenu = null
  menus.forEach(x => {
    if (x.key == menuID) {
      selectedMenu = x
    }
    if (x.child != null) {
      let res = getMenuByKeyExact(x.child, menuID)
      if (res != null) {
        selectedMenu = res
      }
    }
  });
  return selectedMenu
}

export const getMenuByKey = (menus, menuID) => {
  if (!menus || menuID == null) {
    return null
  }
  for (const id of menuKeyVariants(menuID)) {
    const found = getMenuByKeyExact(menus, id)
    if (found != null) {
      return found
    }
  }
  return null
}

const menuNodeHasAccess = (node, access) => {
  if (!node) {
    return false
  }
  if (node.access && node.access[access]) {
    return true
  }
  if (node.child && node.child.length) {
    return node.child.some((child) => menuNodeHasAccess(child, access))
  }
  return false
}

/** True if this module (or any descendant) grants the given access. */
export const getAccessByMenuKeyOrSubtree = (menus, menuID, access) => {
  if (menus == undefined || menus.length == 0) {
    return false
  }
  for (const id of menuKeyVariants(menuID)) {
    const menu = getMenuByKeyExact(menus, id)
    if (menu && menuNodeHasAccess(menu, access)) {
      return true
    }
  }
  return false
}

export const INCOME_STATEMENT_MODULE_KEYS = [
  'income_statement',
  'income-statement',
  'custom-reports',
  'custom_reports',
]

export const RECEIVABLES_MODULE_KEYS = ['receivables']

export function getModuleRouteAccess(menus, moduleKeys, access) {
  if (getAccessByAnyMenuKey(menus, moduleKeys, access)) {
    return true
  }
  return moduleKeys.some((key) => getAccessByMenuKeyOrSubtree(menus, key, access))
}

export const getAccessByMenuKey = (menus, menuID, access) => {
  if (menus == undefined || menus.length == 0) {
    return false
  }
  let menu = getMenuByKey(menus, menuID)
  if (menu != null) {
    return Boolean(menu.access && menu.access[access])
  }
  return false
}

/** ACL key aliases (legacy Sensia vs user-mgmt v2 module keys). */
export const FILE_UPLOADS_MENU_KEYS = [
  'file-uploads',
  'file_uploads',
  'data-integration',
  'auto_payment',
]

/** AR Collection upload (/dashboard/user-file-upload/payment) — legacy + user-mgmt module keys */
export const AR_PAYMENT_MENU_KEYS = [
  'auto_payment',
  'file-uploads',
  'file_uploads',
]

export const getAccessByAnyMenuKey = (menus, menuIDs, access) => {
  if (!Array.isArray(menuIDs)) {
    return getAccessByMenuKey(menus, menuIDs, access)
  }
  return menuIDs.some((id) => getAccessByMenuKey(menus, id, access))
}

export const getIsLeafByMenuKey = (menus, menuID, access) => {
  let menu = getMenuByKey(menus, menuID)
  if (menu != null) {
    return menu.is_leaf
  }
  return false
}

export const getActionOwneruser = (allUser, bu) => {
  //default list by user BU
  let buUser = allUser.filter(x => { return x.bu.toLowerCase() == bu?.toLowerCase() });
  let corporateUser = allUser.filter(x => { return x.role.toLowerCase().indexOf("corporate") > -1 });
  let functionalUser = allUser.filter(x => { return x.role.toLowerCase().indexOf("functional") > -1 });

  let ritvik = allUser.filter(x => { return x.name.toLowerCase() == "ritvik" });
  let sonal = allUser.filter(x => { return x.name.toLowerCase() == "sonal" });
  let asif = allUser.filter(x => { return x.name.toLowerCase() == "asif" });
  let robin = allUser.filter(x => { return x.name.toLowerCase() == "robin" });
  switch (bu && bu.toLowerCase()) {
    case "BU 1":
      buUser = buUser.concat(functionalUser);
      buUser = buUser.concat(ritvik);
      buUser = buUser.concat(sonal);
      buUser = buUser.concat(asif);
     // buUser = buUser.concat(robin);
      break;
    case "BU 2":
    case "BU 3":
      buUser = functionalUser.concat(corporateUser);
      break;
    case "BU 4":
      buUser = buUser.concat(corporateUser);
  }
  buUser = buUser.concat(robin);
  buUser = _.uniqBy(buUser, 'login_id')
  buUser = buUser.sort(
    function (a, b) {
      if (a.role === b.role) {
        // order by role and name
        return a.full_name > b.full_name ? 1 : -1;
      }
      return a.role > b.role ? 1 : -1;
    });
  return buUser
}
export async function getList() {
    const url = `${CONFIG.api_base_url}v1/user-mgmt/user/getall`
    return axios.post(url)
        .then(response => response.data)
        .catch(err => err.response)
}

export const checkPasswordPolicy = (password, policy) => {
  if (!policy) return { policyErrors: ["Policy not loaded yet"] };

  const errors = [];

  const num = new RegExp(`[0-9]{${policy.atleast_numerical_value},}`);
  const lower = new RegExp(`[a-z]{${policy.atleast_lowercase},}`);
  const upper = new RegExp(`[A-Z]{${policy.atleast_uppercase},}`);
//   const symbol = new RegExp(`[!@#$%^&*()_+\\-=\[\]{};':"\\\\|,.<>/?]{${policy.atleast_special_character},}`);
  const symbol = new RegExp(`[!@#$%^&*()_\\-+=[\\]{};':"\\\\|,.<>/?~ ]{${policy.atleast_special_character},}`);

  if (password.length < policy.password_minimum_length)
    errors.push(`Minimum length is ${policy.password_minimum_length}`);
  if (password.length > policy.password_maximum_length)
    errors.push(`Maximum length is ${policy.password_maximum_length}`);
  if (!num.test(password))
    errors.push(`Must contain at least ${policy.atleast_numerical_value} number(s)`);
  if (!lower.test(password))
    errors.push(`Must contain at least ${policy.atleast_lowercase} lowercase letter(s)`);
  if (!upper.test(password))
    errors.push(`Must contain at least ${policy.atleast_uppercase} uppercase letter(s)`);
  if (!symbol.test(password))
    errors.push(`Must contain at least ${policy.atleast_special_character} special character(s)`);

  return errors.length ? { policyErrors: errors } : null;
}